export default __webpack_public_path__ + "static/media/17-cn.a6c1dc0e.webp";